import { Modal, ModalBody, ModalContent, ModalFooter } from '@heroui/react';
import { AppButton } from '@/shared/ui/AppButton';
import { useModalAutoFocus } from '@/shared/lib/hooks';

type TurnitinEulaModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  htmlContent: string;
  onClose: () => void;
  onLoaded: () => void;
  onAccept: () => Promise<boolean>;
};

export const TurnitinEulaModal = ({
  isOpen,
  isLoading,
  htmlContent,
  onClose,
  onLoaded,
  onAccept,
}: TurnitinEulaModalProps) => {
  useModalAutoFocus(isOpen);

  const handleAccept = async () => {
    const success = await onAccept();
    if (!success) {
      // Если не удалось принять, оставить модалку открытой
      return;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onClose}
      placement="center"
      size="xl"
      classNames={{ base: 'max-w-5xl min-w-[95vw]' }}
      isDismissable={false}
    >
      <ModalContent>
        <h3 className="text-xl font-semibold text-center py-5">Turnitin EULA</h3>

        <ModalBody className="p-0">
          <div className="relative px-5">
            <iframe
              title="Turnitin EULA"
              className="h-[80vh] w-full rounded-lg border border-slate-200 pl-5 py-5"
              srcDoc={htmlContent}
              onLoad={onLoaded}
            />
          </div>
        </ModalBody>

        <ModalFooter className="flex justify-end gap-3">
          <AppButton color="white" onPress={onClose}>
            Cancel
          </AppButton>
          <AppButton color="red" onPress={handleAccept} isLoading={isLoading}>
            Accept EULA
          </AppButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
